import { render, staticRenderFns } from "./BtnOk.vue?vue&type=template&id=236c0f03&scoped=true&"
import script from "./BtnOk.vue?vue&type=script&lang=js&"
export * from "./BtnOk.vue?vue&type=script&lang=js&"
import style0 from "./BtnOk.vue?vue&type=style&index=0&id=236c0f03&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236c0f03",
  null
  
)

export default component.exports